import React from 'react';

import Page from '../../common-components/Page';

import UsersSearchForm from './UsersSearchForm';
import UsersTable from './UsersTable';

import * as strings from '../../helpers/strings';
// import PaperContainer from '../../common-components/PaperContainer';
// import Typography from '@material-ui/core/Typography';

const UserListScreen = () => (
  <Page title={strings.lblUsers}>
    {/* <PaperContainer> */}
      {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblUsersList}>{strings.lblUsersList}</Typography> */}
      <UsersSearchForm/>
      <UsersTable/>
    {/* </PaperContainer> */}
  </Page>
)

export default UserListScreen;